import React from 'react';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import Empty from '../../assets/images/empty.png';

const style = {
  border: 'none',
  borderRadius: '18px',
  '.MuiDataGrid-row.Mui-hovered, .MuiDataGrid-row.Mui-selected': {
    backgroundColor: '#E4F8F1',
  },
};

/**
 * TDataGrid component for displaying data in a grid format.
 *
 * @component
 * @param {Object} props
 * @param {Array} props.rows - The data to be displayed in the grid.
 * @param {Array} props.columns - The column configurations for the grid.
 * @param {Array} props.sortModel - The current sort model of the grid.
 * @param {Function} props.setSortModel - Function to update the sort model.
 *
 * @example
 * const rows = [{ id: 1, name: 'John Doe', age: 30 }];
 * const columns = [{ field: 'name', headerName: 'Name' }, { field: 'age', headerName: 'Age' }];
 * const sortModel = [{ field: 'name', sort: 'asc' }];
 * const setSortModel = (model) => console.log(model);
 *
 * return (
 *   <TDataGrid
 *     rows={rows}
 *     columns={columns}
 *     sortModel={sortModel}
 *     setSortModel={setSortModel}
 *   />
 * );
 */
function TDataGrid({ rows, columns, sortModel, setSortModel }) {
  return (
    <DataGrid
      getRowId={() => Math.random()}
      rows={rows}
      sx={style}
      columns={columns}
      autoHeight
      hideFooter
      showColumnRightBorder
      sortingMode="server"
      className="report-list-table-area-table"
      disableColumnMenu
      sortModel={sortModel}
      onSortModelChange={setSortModel}
      checkboxSelection={false}
      components={{
        NoRowsOverlay: () => (
          <div className="flex flex-col justify-center items-center">
            <img src={Empty} className="w-20 h-20" alt="Bulunamadı" />
            <h1 className="font-bold">Veri Bulunamadı</h1>
          </div>
        ),
        NoResultsOverlay: () => (
          <div className="flex flex-col justify-center items-center">
            <img src={Empty} className="w-20 h-20" alt="Bulunamadı" />
            <h1 className="font-bold">
              Aradığınız kriterlere uygun veri bulunamadı.
            </h1>
          </div>
        ),
      }}
    />
  );
}

TDataGrid.propTypes = {
  /**
   * The data to be displayed in the grid.
   */
  rows: PropTypes.array.isRequired,
  /**
   * The column configurations for the grid.
   */
  columns: PropTypes.array.isRequired,
  /**
   * The current sort model of the grid.
   */
  sortModel: PropTypes.array,
  /**
   * Function to update the sort model.
   */
  setSortModel: PropTypes.func.isRequired,
};

export default TDataGrid;
